// Dependencies
import {
  TIPOS_MARGEN_REQUEST,
  TIPOS_MARGEN_OK,
  TIPOS_MARGEN_ERROR,
} from "./types";
import { get } from "../../../../api/apiInstance";

const fetchTiposMargen = () => async (dispatch) => {
  try {
    const response = await get("/margenes/tipos_margen");
    const data = response["data"];
    dispatch({
      type: TIPOS_MARGEN_OK,
      payload: { data: data["data"], qty: data["rowsAffected"] },
    });
    return Promise.resolve();
  } catch (error) {
    dispatch({ type: TIPOS_MARGEN_ERROR, payload: error });
    return Promise.reject(error);
  }
};

export const getTiposMargen = () => (dispatch) => {
  dispatch({ type: TIPOS_MARGEN_REQUEST });
  dispatch(fetchTiposMargen());
};
